import React, { useState, useEffect } from 'react'
import './about.css'
import Typewriter from 'typewriter-effect';
import { useInView } from 'react-intersection-observer';
import {FaCode} from 'react-icons/fa'
import {FiSettings} from 'react-icons/fi'
import {BsCart3} from 'react-icons/bs'

const About = () => {

  const [typewriterInstance, setTypewriterInstance] = useState(null);

  const { ref, inView } = useInView({
    threshold: 0.5, 
    triggerOnce: true, 
  });

  useEffect(() => {
    if (inView && typewriterInstance) {
      typewriterInstance.start();
    }
  }, [inView, typewriterInstance]);

  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
        <div className="about_me">
          {/* ref={ref} ile bu kutuyu izlemeye alıyoruz */}
          <div className="about_code_box" ref={ref}>
              <div className="code_header">
                  <span className="dot red"></span>
                  <span className="dot yellow"></span>
                  <span className="dot green"></span>
                  <span className="file_name">Routine.java</span>
              </div>

              <div className="code_content">
                <Typewriter
                  options={{
                    autoStart: false,
                    loop: false,
                    delay: 40,
                    cursor: '|',
                  }}
                  onInit={(typewriter) => {
                    setTypewriterInstance(typewriter);

                    typewriter
                      .typeString('<span class="keyword">while</span> (<span class="boolean">alive</span>) {')
                      .typeString('<br/>')
                      
                      .typeString('  <span class="function">eat</span>();')
                      .typeString('<br/>')
                      
                      .typeString('  <span class="function">sleep</span>();')
                      .typeString('<br/>')
                      
                      .typeString('  <span class="function">code</span>();')
                      .typeString('<br/>')
                      
                      .typeString('  <span class="keyword">if</span> (!<span class="variable">works</span>) {')
                      .typeString('<br/>')
                      
                      .typeString('    <span class="comment">// It works on my machine! 🤷‍♂️</span>')
                      .typeString('<br/>')
                      
                      .typeString('    travel.<span class="function">explore</span>();')
                      .typeString('<br/>')
                      
                      // SORUN ÇIKARAN SATIR BUYDU, ARTIK DÜZELDİ:
                      .typeString('  }') 
                      .typeString('<br/>')
                      
                      .typeString('}')
                  }}
                />
              </div>
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className='about_card'>
              <FaCode className='about_icon'/>
              <h5>Software Development</h5>
              <small>Web applications, backend services and full-stack systems.</small>
            </article>

            <article className='about_card'>
              <FiSettings className='about_icon'/>
              <h5>Business Systems</h5>
              <small>Internal tools, reporting systems and workflow automation.</small>
            </article>

            <article className='about_card'>
              <BsCart3 className='about_icon'/>
              <h5>Web & E-commerce</h5>
              <small>Web platforms, e-commerce systems and integrations.</small>
            </article>
          </div>

          <p>
          I'm a Software Developer based in İzmir, working mainly with Java, Spring Boot, React, Next.js, TypeScript and PostgreSQL.
          <br /><br />
          I build web applications, backend services and internal tools used in real business processes. My work includes REST APIs, database-driven applications, reporting systems, workflow automation, e-commerce integrations and full-stack web applications.
          <br /><br />
          In my current role, I work on both customer-facing web systems and internal software solutions that support day-to-day business operations. I enjoy understanding how a process works, identifying where software can improve it, and building practical solutions around those needs.
          <br /><br />
          My experience also includes PHP, WordPress/WooCommerce, e-commerce systems and technical SEO. I see these as complementary skills that give me a broader understanding of the systems and business processes surrounding the software I develop.
          <br /><br />
          My current focus is on backend development, software architecture, system design, testing, integrations and AI-assisted development workflows.
          </p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About